import { type ReactElement } from 'react';
import { Flex, DivSkeleton } from '@fastnorth/kraken/components/layout';
import AvatarSkeleton from '@fastnorth/kraken/components/avatar';
import { useResponsive } from '@fastnorth/kraken/components/page-layout';

const ParticipantDetailsSkeleton = (): ReactElement => {
  const { isMobile } = useResponsive();
  return (
    <Flex
      className={'flex-row items-start w-full'}
      gap={'6'}
      data-testid="participant-details-skeleton">
      <Flex className={`flex-shrink-0 ${isMobile ? 'size-[56px]' : 'size-[72px]'}`}>
        <AvatarSkeleton size="full" fallback="" />
      </Flex>
      <Flex className={'flex-col w-full'} gap={'3'}>
        <DivSkeleton className={'w-[200px] h-[32px]'} />
        <DivSkeleton className={'w-[50px] h-[24px]'} />
        <DivSkeleton className={'w-[300px] h-[20px]'} />
      </Flex>
    </Flex>
  );
};

export default ParticipantDetailsSkeleton;
